import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ProgressiveImage from '../progressive-image/progressive-image'
import Link from '../../core/patterns/link/link'

import styles from './signup.css'

export default class SignUp extends Component {
  static propTypes = {
    signedIn: PropTypes.bool.isRequired,
    images: PropTypes.object.isRequired,
    texts: PropTypes.object.isRequired,
    ctas: PropTypes.object.isRequired,
    links: PropTypes.object.isRequired,
  }

  render() {
    const { signedIn, images, texts, ctas, links } = this.props
    const image = signedIn ? images.loggedin : images.notloggedin
    const text = signedIn ? texts.loggedin : texts.notloggedin
    const cta = signedIn ? ctas.loggedin : ctas.notloggedin
    const link = signedIn ? links.loggedin : links.notloggedin

    return (
      <div className={styles['container']}>
        <div className={styles['image']}>
          <ProgressiveImage alt="" src={image} />
        </div>

        <section className={styles['wrapper']}>
          <p className={styles['text']}>{text}</p>
          <Link href={link} className={styles['button']} mode="filled">
            {cta}
          </Link>
        </section>
      </div>
    )
  }
}
